const TOAST_CONTAINER_ID = "admin-action-toast-container";
const TOAST_STYLE_ID = "admin-action-toast-style";
const TOAST_DURATION_MS = 4500;

const isAuthError = (error) =>
	Boolean(error?.isAuthError) ||
	error?.status === 401 ||
	error?.status === 403;

const getDisplayMessage = (error, fallback) => {
	const message = typeof error?.message === "string" ? error.message.trim() : "";

	if (!message) return fallback;
	if (
		message === "Failed to fetch" ||
		message === "Network request failed" ||
		message === "Load failed" ||
		message === "The user aborted a request."
	) {
		return "Нет соединения с сервером. Попробуйте ещё раз.";
	}
	if (/^HTTP error/i.test(message)) return fallback;

	return message;
};

const ensureStyle = () => {
	if (document.getElementById(TOAST_STYLE_ID)) return;
	const style = document.createElement("style");
	style.id = TOAST_STYLE_ID;
	style.textContent = `
		#${TOAST_CONTAINER_ID} {
			position: fixed;
			top: 16px;
			right: 16px;
			z-index: 99999;
			display: flex;
			flex-direction: column;
			gap: 8px;
			pointer-events: none;
			max-width: calc(100vw - 32px);
		}
		.admin-action-toast {
			pointer-events: auto;
			background: #b3253a;
			color: #fff;
			padding: 12px 16px;
			border-radius: 10px;
			font-size: 14px;
			line-height: 1.4;
			box-shadow: 0 6px 20px rgba(0,0,0,0.18);
			max-width: 360px;
			word-break: break-word;
			opacity: 0;
			transform: translateY(-6px);
			transition: opacity 200ms ease, transform 200ms ease;
		}
		.admin-action-toast.is-success {
			background: #2f7d4f;
		}
		.admin-action-toast.is-visible {
			opacity: 1;
			transform: translateY(0);
		}
	`;
	document.head.appendChild(style);
};

const ensureContainer = () => {
	let container = document.getElementById(TOAST_CONTAINER_ID);
	if (container) return container;
	container = document.createElement("div");
	container.id = TOAST_CONTAINER_ID;
	document.body.appendChild(container);
	return container;
};

const renderToast = (message, variant = "error") => {
	ensureStyle();
	const container = ensureContainer();

	const toast = document.createElement("div");
	toast.className =
		variant === "success"
			? "admin-action-toast is-success"
			: "admin-action-toast";
	toast.textContent = message;
	toast.setAttribute("role", variant === "success" ? "status" : "alert");
	container.appendChild(toast);

	requestAnimationFrame(() => {
		toast.classList.add("is-visible");
	});

	const remove = () => {
		toast.classList.remove("is-visible");
		setTimeout(() => {
			toast.remove();
		}, 220);
	};

	toast.addEventListener("click", remove);
	setTimeout(remove, TOAST_DURATION_MS);
};

export const showActionError = (error, fallback = "Ошибка выполнения действия") => {
	if (isAuthError(error)) return;

	if (typeof window === "undefined" || typeof document === "undefined") return;

	renderToast(getDisplayMessage(error, fallback), "error");
};

export const showActionSuccess = (message) => {
	if (typeof window === "undefined" || typeof document === "undefined") return;
	if (!message) return;

	renderToast(String(message), "success");
};

export default showActionError;
